import {GlobalConfig} from 'ngx-toastr';

export const customNotifierOptions: Partial<GlobalConfig> = {
  positionClass: 'toast-bottom-left',
  timeOut: 3000,
  closeButton: true,
  tapToDismiss: true,
  progressBar: true,
  maxOpened: 4,
  autoDismiss: true,
  newestOnTop: true,
  easing: 'ease',
  extendedTimeOut: 3000,
  progressAnimation: 'decreasing',
};
